import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";

export const useCreatorDirectoryFeedStore = defineSmartFeedPiniaStore("creator-directory-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    feedUrl: "/org/creators/smart-feed",
    metadata: {
      lastId: Number.MAX_SAFE_INTEGER,
    },
  }),
});
